import Axios from 'lib/Axios';
import { APIResponse } from 'types/APIResponse';
import { DefaultPagination } from 'types/common';
import { OfferOfTheDay } from 'types/Offers';

export const _GetOffersOfTheDay = (params?: DefaultPagination) =>
  Axios.get<APIResponse<OfferOfTheDay[]>>('/offers/offer-of-the-day', { params }).then((res) => res.data);
